import { Component } from 'react';

export class ArrowSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="23"
                viewBox="0 0 29 23"
            >
                <path
                    fill="#0C2340"
                    stroke="#FFF"
                    className={className}
                    strokeWidth="2"
                    d="M17.664 21.712l10.037-9.55c.399-.38.399-.975 0-1.327l-10.037-9.55c-.399-.38-1.024-.38-1.394 0l-1.08 1.027c-.399.38-.399.974 0 1.326l6.455 6.142H1.995c-.54 0-.995.433-.995.947v1.434c0 .514.455.947.995.947h19.792l-6.597 6.277c-.399.38-.399.975 0 1.326l1.08 1.028c.398.352 1.024.352 1.394-.027z"
                    opacity=".802"
                />
            </svg>
        );
    }
}
